import { Injectable } from '@angular/core';
import { Configuration } from '@content-platform/web-angular-shared-util-configuration';
import { catchError, filter, forkJoin, of, take } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
const SOURCE_TYPE = 'FRONT-END';
const EVENT_VERSION = 1.2;
export var eventTypeEnum;
(function (eventTypeEnum) {
    eventTypeEnum["SUBMISSION"] = "SUBMISSION";
    eventTypeEnum["DEBUG_FLAG"] = "DEBUG_FLAG";
    eventTypeEnum["REGISTRATION"] = "REGISTRATION";
    eventTypeEnum["GEOLOCATION"] = "GEOLOCATION_SUBMISSION";
    eventTypeEnum["USER_EXT_CREATE"] = "USER_EXT_CREATE";
    eventTypeEnum["USER_EXT_INVITE"] = "USER_EXT_INVITE";
    eventTypeEnum["USER_EXT_GROUP"] = "USER_EXT_GROUP";
    eventTypeEnum["USER_EXT_REQUEST"] = "USER_EXT_REQUEST";
    eventTypeEnum["USER_LOGGED_IN"] = "USER_LOGGED_IN";
    eventTypeEnum["SEARCH_HISTORY"] = "SEARCH_HISTORY";
    eventTypeEnum["REDIRECT"] = "REDIRECT";
    eventTypeEnum["REGGIE_UPDATE_CLICK"] = "REGGIE_UPDATE_CLICK";
    eventTypeEnum["REGGIE_CANCEL_CLICK"] = "REGGIE_CANCEL_CLICK";
    eventTypeEnum["REGGIE_SUBMISSION_ERROR_LOG"] = "REGGIE_SUBMISSION_ERROR_LOG";
})(eventTypeEnum || (eventTypeEnum = {}));
export var actionEnum;
(function (actionEnum) {
    actionEnum["CREATE"] = "CREATE";
    actionEnum["READ"] = "READ";
    actionEnum["UPDATE"] = "UPDATE";
    actionEnum["DELETE"] = "DELETE";
    actionEnum["SEARCH"] = "SEARCH";
})(actionEnum || (actionEnum = {}));
export class MegaBeaconService {
    constructor(httpClient) {
        this.httpClient = httpClient;
        forkJoin(Configuration.getAsync('adal').pipe(filter(config => !!config), take(1)), Configuration.getAsync('environment').pipe(filter(config => !!config), take(1)), Configuration.getAsync('megaBeacon').pipe(filter(config => !!config), take(1))).subscribe(([res1, res2, res3]) => {
            this.clientId = res1.clientId;
            this.environment = res2;
            this.megaBeaconUrl = res3.url;
            this.schemaUrl = res3.schemaUrl;
        });
    }
    /**
     * Logs an event to Mega Beacon
     *
     * @param {string} caller The calling component/service/class
     * @param {eventType} eventType Event type to be logged (SUBMISSION|REGISTRATION|USER_LOGGED_IN)
     * @param {action} action Action to be logged (CREATE|READ|UPDATE|DELETE|SEARCH)
     * @param {ActionParams} params Extra parameters to be logged
     * @param {AdditionalDataParams} additionalData The additional data to log (Optional)
     * @param {schema} schema JSON schema's URL to validate additional data
     * @memberof MegaBeaconService
     */
    log(eventType, action, params, jsonSchemaFileName, additionalData) {
        const actionParams = this.createActionParams(params, eventType, action, jsonSchemaFileName, additionalData);
        return this.sendData(actionParams).pipe(response => response);
    }
    createActionParams(params, eventType, action, jsonSchemaFileName, additionalData) {
        const actionParams = {
            events: [
                {
                    $schema: `${this.schemaUrl}${jsonSchemaFileName}`,
                    event_version: EVENT_VERSION,
                    requestor: {
                        user: {
                            id: params.uuid,
                            email: params.userName,
                            name: params.name,
                            user_type: params.userType
                        },
                        application: {
                            id: this.clientId,
                            name: params.activeApplication.toUpperCase(),
                            type: SOURCE_TYPE
                        }
                    },
                    source: params.activeApplication.toUpperCase(),
                    source_type: SOURCE_TYPE,
                    deeplink: params.url,
                    env: this.environment,
                    action: action,
                    event_type: eventType,
                    time: new Date().toISOString(),
                    additional_data: additionalData
                }
            ]
        };
        return actionParams;
    }
    sendData(params) {
        return this.httpClient.post(this.megaBeaconUrl, params).pipe(response => response, catchError(error => of(error)));
    }
    static { this.ɵfac = function MegaBeaconService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MegaBeaconService)(i0.ɵɵinject(i1.HttpClient)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MegaBeaconService, factory: MegaBeaconService.ɵfac }); }
}
//# sourceMappingURL=mega-beacon.service.js.map